import React, { Dispatch, SetStateAction, useMemo } from 'react'

import { Button, Grid, Typography } from '@barracuda-internal/bds-core'

import { useFormatMessage } from 'lib/localization'
import { FormSpacer } from 'components/libs/layout/pages/pageLayout'
import styles from 'components/pages/inboundSettings/inboundSettingsStyles'
import DomainTable from 'components/libs/domainTable/DomainTable'
import { useIsReadonly } from 'lib/hooks/useIsReadonly'
import { useWarningBannerExemptLogic } from './useWarningBannerExemptLogic'

const BASE_I18N_KEY = 'ess.inbound_settings.anti_phishing'
const BASE_INBOUND_I18N_KEY = 'ess.inbound_settings'

export interface WarningBannerExemptProps {
  delegateDirtyFormState: Dispatch<SetStateAction<boolean>>
}

const WarningBannerExempt: React.FC<WarningBannerExemptProps> = (props: WarningBannerExemptProps) => {
  const isReadonly = useIsReadonly()
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const formatInboundMessage = useFormatMessage(BASE_INBOUND_I18N_KEY)
  const inboundClasses = styles()
  const [state, eventHandlers] = useWarningBannerExemptLogic()

  return useMemo(
    () => (
      <Grid container data-testid="warning-banner-exempt-section">
        <Typography variant="h4">{formatMessage('warning_banner_exemptions')}</Typography>
        <FormSpacer />
        <Button
          className={inboundClasses.bulkEdit}
          onClick={eventHandlers.onBulkEdit}
          variant="contained"
          size="small"
          data-testid="bulk-button-warning-banner"
          disabled={isReadonly}
        >
          {formatInboundMessage('bulk_edit')}
        </Button>
        <DomainTable
          data={state.tableData}
          onAddItem={eventHandlers.onAddItem}
          onRemoveItem={eventHandlers.onRemoveItem}
          shouldHandleEmail
          isLoading={state.isLoading}
          data-testid="warning-banner-exempt-table"
          delegateDirtyFormState={props.delegateDirtyFormState}
        />
      </Grid>
    ),
    [
      formatMessage,
      formatInboundMessage,
      inboundClasses.bulkEdit,
      eventHandlers,
      state.tableData,
      state.isLoading,
      isReadonly,
      props.delegateDirtyFormState
    ]
  )
}

export default WarningBannerExempt
